import { Link } from "react-router-dom";
import { useGetBlogQuery } from "./blogApiSlice";
import { useGetTagQuery } from "./useTagApiSlice";
import { useState, useEffect } from "react";

const BlogList = () => {
  const [blogs, setblogs] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const {
    isSuccess: isSuccessGetBlog,
    isError: isErrorGetBlog,
    error: errorBlogError,
    data: getBlogData,
  } = useGetBlogQuery();

  const {
    isSuccess: isSuccessGetTag,
    isError: isErrorGetTag,
    error: getTagError,
    data: getTagData,
  } = useGetTagQuery();

  useEffect(() => {
    if (isSuccessGetBlog) {
      // alert(dataGetBlog.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
      setblogs(Object.values(getBlogData.entities || {}));
    }

    if (isErrorGetBlog) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorBlogError?.data?.message);
    }
  }, [isSuccessGetBlog, isErrorGetBlog, errorBlogError, getBlogData]);

  useEffect(() => {
    if (isSuccessGetTag) {
      //   alert(getTagData.message.toString());
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
      setTags(Object.values(getTagData.entities || {}));
    }

    if (isErrorGetTag) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(getTagError?.data?.message);
    }
  }, [isSuccessGetTag, isErrorGetTag, getTagError, getTagData]);

  function formatDateToReadable(dateStr) {
    const date = new Date(dateStr);

    const readableDate = date.toLocaleDateString("sr-RS", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    });

    return readableDate;
  }

  // const formattedDate = formatDateToReadable("2025-01-09T20:43:19.131Z");
  // console.log(formattedDate);

  // useEffect(() => {
  //   console.log("blogs", blogs);
  // }, [blogs]);

  const handleTagChange = (event, tag) => {
    if (event.target.checked) {
      setSelectedTags([...selectedTags, tag]);
    } else {
      setSelectedTags(
        selectedTags.filter((selectedTag) => selectedTag !== tag)
      );
    }
  };

  //Jedan nacin filtracije
  // const filtered = blogs.filter((blog) =>
  //   // blog.tip === "true" &&
  //   selectedTags.some((tag) => blog.tags && blog.tags.includes(tag))
  // );

  //Drugi nacin filtracije
  const filtered = blogs.filter(
    (blog) =>
      selectedTags.length === 0 || // Ako nema selektovanih tagova, prikazujemo sve
      selectedTags.some((tag) => blog.tags && blog.tags.includes(tag)) // Inače filtriramo po tagovima
  );

  return (
    <>
      <div>
        <br />
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Naši blogovi
          </h2>
          <p className="mt-2 text-lg/8 text-gray-600">
            Ovde možete videti sve naše blogove o nutricionizmu.
          </p>

          <div className="flex flex-wrap justify-center gap-6">
            {tags.map((tag, index) => (
              <div className="flex items-center" key={index}>
                <label className="flex items-center gap-3 cursor-pointer hover:bg-green-100 hover:text-green-700 p-2 rounded-lg transition duration-200 ease-in-out">
                  <input
                    type="checkbox"
                    value={tag.naziv}
                    className="form-checkbox h-6 w-6 text-green-600 border-green-400 rounded-md transition duration-200 ease-in-out focus:ring-2 focus:ring-green-500"
                    onChange={(event) => handleTagChange(event, tag.naziv)}
                  />
                  <span className="text-lg font-medium text-green-700">
                    {tag.naziv}
                  </span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-5">
          {filtered.length > 0 ? (
            filtered
              .slice()
              .reverse()
              .map((blog) => (
                <div
                  className="bg-white rounded-lg shadow-md overflow-hidden"
                  key={blog.id}
                >
                  <Link to={`${blog.id}`} className="block">
                    {/* <img
                      src={blog.slika}
                      alt="Placeholder Image"
                      className="w-full h-48 object-cover"
                    /> */}
                    <img
                      src={blog.slika}
                      alt="Placeholder Image"
                      className="w-full h-48 object-cover object-center md:object-top"
                    />
                    <div className="p-4">
                      <div className="flex items-center justify-between">
                        <h2 className="text-xl font-semibold text-gray-900">
                          {blog.title}
                        </h2>
                        <div className="flex flex-wrap space-x-2">
                          {Array.isArray(blog.tags) ? (
                            blog.tags.map((tag, index) => (
                              <span
                                key={index}
                                className="inline-block px-3 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 cursor-pointer"
                              >
                                {tag}
                              </span>
                            ))
                          ) : (
                            <span className="text-red-600">
                              Tagovi nisu u pravilnom formatu.
                            </span>
                          )}
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mt-2">
                        Autor: {blog.author}
                      </p>
                      <p className="text-sm text-gray-600">
                        Datum: {formatDateToReadable(blog.date)}
                      </p>
                    </div>
                  </Link>
                </div>
              ))
          ) : (
            <h2 className="text-xl font-semibold text-center text-red-500">
              Molim Vas da sačekajte...
            </h2>
          )}
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      {/* <div>
        <br />
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Naši blogovi
          </h2>
          <p className="mt-2 text-lg/8 text-gray-600">
            Ovde možete videti sve naše blogove o nutricionizmu.
          </p>

          <div className="flex flex-wrap justify-center gap-6">
            {tags.map((tag, index) => (
              <div className="flex items-center" key={index}>
                <label className="flex items-center gap-3 cursor-pointer hover:bg-green-100 hover:text-green-700 p-2 rounded-lg transition duration-200 ease-in-out">
                  <input
                    type="checkbox"
                    value={tag.naziv}
                    className="form-checkbox h-6 w-6 text-green-600 border-green-400 rounded-md transition duration-200 ease-in-out focus:ring-2 focus:ring-green-500"
                    onChange={(event) => handleTagChange(event, tag.naziv)}
                  />
                  <span className="text-lg font-medium text-green-700">
                    {tag.naziv}
                  </span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 p-5">
          {filtered.length > 0 ? (
            filtered.map((blog) => (
              <div
                className="bg-white rounded-lg shadow-md overflow-hidden"
                key={blog.id}
              >
                <Link to={`${blog.id}`} className="block">
                  <img
                    src={blog.slika}
                    alt="Placeholder Image"
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <div className="flex items-center justify-between">
                      <h2 className="text-xl font-semibold text-gray-900">
                        {blog.title}
                      </h2>
                      <div className="flex flex-wrap space-x-2">
                        {Array.isArray(blog.tags) ? (
                          blog.tags.map((tag, index) => (
                            <span
                              key={index}
                              className="inline-block px-3 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium hover:bg-green-300 transition duration-300 cursor-pointer"
                            >
                              {tag}
                            </span>
                          ))
                        ) : (
                          <span className="text-red-600">
                            Tagovi nisu u pravilnom formatu.
                          </span>
                        )}
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                      Autor: {blog.author}
                    </p>
                    <p className="text-sm text-gray-600">
                      Datum: {formatDateToReadable(blog.date)}
                    </p>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <h2 className="text-xl font-semibold text-center text-red-500">
              Molim Vas da sačekajte...
            </h2>
          )}
        </div>
      </div>
      <br />
      <br />
      <br />
      <br /> */}
    </>
  );
};

export default BlogList;
